import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2bfa9f13"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table-container" }
const _hoisted_2 = {
  key: 0,
  class: "table-bordered"
}
const _hoisted_3 = { class: "table-header" }
const _hoisted_4 = {
  key: 0,
  scope: "col",
  class: "w-25"
}
const _hoisted_5 = ["onClick", "onDbclick"]
const _hoisted_6 = {
  key: 0,
  class: "actions"
}
const _hoisted_7 = { class: "btn-container" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]

import { Headers } from '@/interfaces/IProject';
    

    // TODO: Encontrar solucion más adecuada
    // Solucion fea pero funcional
    interface T {
        [key: string]: string | number | boolean | Date
    }
    
    
export default /*#__PURE__*/_defineComponent({
  __name: 'TableComponent',
  props: {
        headers: {
            type: Array as () => Headers[]
        },
        data: {
            //TODO change any
            type: Array as () => T[],
        },
        noActions: {
            type: Boolean
        }
    },
  emits: ['returnSelectedRow', 'returnSelectedRowDoubleClick', 'deleteCurrentRow', 'editCurrentRow'],
  setup(__props, { emit: __emit }) {

    const props = __props

    const emit = __emit;

    const selectRow = (row: T) => {
        console.log("Seleccionado: ", row)
        emit('returnSelectedRow', row);
    }

    const selectRowDoubleClick = (row: T) => {
        console.log("Doble click: ", row)
        emit('returnSelectedRowDoubleClick', row);
    }

    const deleteRow = (row: T) => {
        emit('deleteCurrentRow', row);
    }

    const editRow = (row: T) => {
        emit('editCurrentRow', row);
    }

return (_ctx: any,_cache: any) => {
  const _component_IconifyIcon = _resolveComponent("IconifyIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.data && props.headers)
      ? (_openBlock(), _createElementBlock("table", _hoisted_2, [
          _createElementVNode("thead", _hoisted_3, [
            _createElementVNode("tr", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.headers, (header, index) => {
                return (_openBlock(), _createElementBlock("th", {
                  scope: "col",
                  key: index
                }, _toDisplayString(header.name), 1))
              }), 128)),
              (!__props.noActions)
                ? (_openBlock(), _createElementBlock("th", _hoisted_4, "Acciones"))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.data, (row, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                class: "table-row",
                key: index,
                onClick: ($event: any) => (selectRow(row)),
                onDbclick: ($event: any) => (selectRowDoubleClick(row))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.headers, (header, index) => {
                  return (_openBlock(), _createElementBlock("td", {
                    class: _normalizeClass({ 'pointer': props.noActions }),
                    key: index
                  }, _toDisplayString(row[header.dbName]), 3))
                }), 128)),
                (!__props.noActions)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("button", {
                          class: "btn btn-primary",
                          onClick: ($event: any) => (editRow(row))
                        }, [
                          _createVNode(_component_IconifyIcon, {
                            icon: "mdi:pencil",
                            width: "20px"
                          })
                        ], 8, _hoisted_8),
                        _createElementVNode("button", {
                          class: "btn btn-danger",
                          onClick: ($event: any) => (deleteRow(row))
                        }, [
                          _createVNode(_component_IconifyIcon, {
                            icon: "mdi:delete",
                            width: "20px"
                          })
                        ], 8, _hoisted_9)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 40, _hoisted_5))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})